var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCircularSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4005 7.57484C17.9689 8.58986 18.2924 9.75745 18.2924 10.9997C18.2924 14.9111 15.0849 18.0819 11.1282 18.0819H11.1279V15.445L3.33608 18.8535C5.34341 20.7998 8.0937 22 11.1276 22C17.2732 22 22.2551 17.0751 22.2551 11C22.2551 9.19362 21.8147 7.48894 21.0341 5.98519L17.4005 7.57484ZM18.9191 3.14656C16.9117 1.20023 14.1614 0 11.1276 0C4.98198 0 0 4.92487 0 11C0 12.8064 0.440465 14.5111 1.22102 16.0148L4.85589 14.4248C4.28747 13.4097 3.96386 12.2421 3.96386 10.9997C3.96386 7.08845 7.1713 3.91771 11.1279 3.91759V6.55505L18.9191 3.14656Z",
    fill: "#51CE92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircularSymbol);
export default __webpack_public_path__ + "static/media/Logo-Circular-Symbol.01757ae2e15f3457e586409bb50f4f08.svg";
export { ForwardRef as ReactComponent };